// extracted by mini-css-extract-plugin
export default {"cls1":"RemovedItemNotice-cls1_jPr","cls2":"RemovedItemNotice-cls2_Fo2 RemovedItemNotice-cls1_jPr"};